var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "FileInput form-group"
  }, [_c('label', {
    staticClass: "FileInput-label p-2 font-weight-bold",
    class: {
      'FileInput-label--draggedOver': _vm.draggedOver,
      'FileInput-label--filled': _vm.value && _vm.value.slug
    },
    attrs: {
      "for": _vm.id,
      "data-qa": ((_vm.qa) + ".label")
    },
    on: {
      "dragover": function ($event) {
        $event.preventDefault();
        _vm.draggedOver = true;
      },
      "dragleave": function ($event) {
        $event.preventDefault();
        _vm.draggedOver = false;
      },
      "drop": function ($event) {
        $event.preventDefault();
        return _vm.uploadMedia($event.dataTransfer.files);
      }
    }
  }, [_c('input', {
    staticClass: "FileInput-hiddenInput form-control-file",
    attrs: {
      "id": _vm.id,
      "data-qa": ((_vm.qa) + ".input"),
      "type": "file"
    },
    on: {
      "change": function ($event) {
        return _vm.uploadMedia($event.target.files);
      }
    }
  }), !_vm.uploadingMedia ? _c('i', {
    staticClass: "FileInput-icon fa fa-upload",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm.uploadingMedia ? _c('i', {
    staticClass: "FileInput-icon fas fa-spinner fa-spin"
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.label) + " ")]), _vm.captureLabel !== '' ? _c('label', {
    staticClass: "\n      d-flex\n      p-2\n      align-items-center\n      justify-content-center\n      col-xs-auto\n      btn btn-lg btn-primary\n      text-right text-white\n      d-md-none\n      file-input-label\n    "
  }, [_c('input', {
    staticClass: "FileInput-hiddenInput form-control-file",
    attrs: {
      "data-qa": ((_vm.qa) + ".input-capture"),
      "type": "file",
      "accept": "image/*",
      "capture": "user"
    },
    on: {
      "change": function ($event) {
        return _vm.uploadMedia($event.target.files);
      }
    }
  }), !_vm.uploadingMedia ? _c('i', {
    staticClass: "FileInput-icon fa fa-camera",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "FileInput-icon fas fa-spinner fa-spin"
  }), _vm._v(" " + _vm._s(_vm.captureLabel) + " ")]) : _vm._e()]), _vm.value && _vm.value.slug ? _c('div', [_c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', {
    staticClass: "FileInput-slug"
  }, [_c('i', {
    staticClass: "fa fa-paperclip"
  }), _vm._v(" " + _vm._s(_vm.value.name) + " ")])])]) : _vm._e(), _c('div', {
    staticClass: "FileInput-error",
    class: {
      'FileInput-error--displayed': _vm.errorLabel !== '' || _vm.error
    },
    attrs: {
      "id": 'js-error-' + _vm.inputId,
      "aria-label": _vm.errorLabel || _vm.error,
      "tabindex": _vm.getErrorTabIndex
    }
  }, [_vm._v(" " + _vm._s(_vm.errorLabel || _vm.size.errorMessage) + " ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }